/** Read safe summary — migration 142 `regulated_actor_context` cohort. */
export const HI_PATIENT_IDENTITY_READ_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'COORDINATOR',
  'CASE_MANAGER',
  'CLINICAL_LEAD',
  'REGISTERED_NURSE',
] as const;

/** Manual capture — coordination/admin write cohort; not frontline clinical. */
export const HI_PATIENT_IDENTITY_MANUAL_CAPTURE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'COORDINATOR',
  'CASE_MANAGER',
] as const;

/** Agency validation prepare/apply and demographic stale gate — includes clinical lead. */
export const HI_PATIENT_IDENTITY_AGENCY_VALIDATE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'COORDINATOR',
  'CASE_MANAGER',
  'CLINICAL_LEAD',
] as const;

/** Restricted full-envelope disclosure — privileged clinical governance only. */
export const HI_PATIENT_IDENTITY_DISCLOSURE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CLINICAL_LEAD',
] as const;

/** Duplicate candidate lookup — coordination plus clinical lead. */
export const HI_PATIENT_IDENTITY_DUPLICATE_FIND_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'COORDINATOR',
  'CASE_MANAGER',
  'CLINICAL_LEAD',
] as const;

/** Duplicate review decision — same narrow cohort as disclosure. */
export const HI_PATIENT_IDENTITY_DUPLICATE_DECISION_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CLINICAL_LEAD',
] as const;

export type HiPatientIdentityReadRole = (typeof HI_PATIENT_IDENTITY_READ_ROLES)[number];
export type HiPatientIdentityManualCaptureRole =
  (typeof HI_PATIENT_IDENTITY_MANUAL_CAPTURE_ROLES)[number];
export type HiPatientIdentityAgencyValidateRole =
  (typeof HI_PATIENT_IDENTITY_AGENCY_VALIDATE_ROLES)[number];
export type HiPatientIdentityDisclosureRole = (typeof HI_PATIENT_IDENTITY_DISCLOSURE_ROLES)[number];
export type HiPatientIdentityDuplicateFindRole =
  (typeof HI_PATIENT_IDENTITY_DUPLICATE_FIND_ROLES)[number];
export type HiPatientIdentityDuplicateDecisionRole =
  (typeof HI_PATIENT_IDENTITY_DUPLICATE_DECISION_ROLES)[number];

export function canReadHiPatientIdentitySummary(role: string): role is HiPatientIdentityReadRole {
  return (HI_PATIENT_IDENTITY_READ_ROLES as readonly string[]).includes(role);
}

export function canCaptureHiPatientIdentityManual(
  role: string,
): role is HiPatientIdentityManualCaptureRole {
  return (HI_PATIENT_IDENTITY_MANUAL_CAPTURE_ROLES as readonly string[]).includes(role);
}

export function canValidateHiPatientIdentityAgency(
  role: string,
): role is HiPatientIdentityAgencyValidateRole {
  return (HI_PATIENT_IDENTITY_AGENCY_VALIDATE_ROLES as readonly string[]).includes(role);
}

export function canDiscloseHiPatientIdentity(
  role: string,
): role is HiPatientIdentityDisclosureRole {
  return (HI_PATIENT_IDENTITY_DISCLOSURE_ROLES as readonly string[]).includes(role);
}

export function canFindHiPatientIdentityDuplicates(
  role: string,
): role is HiPatientIdentityDuplicateFindRole {
  return (HI_PATIENT_IDENTITY_DUPLICATE_FIND_ROLES as readonly string[]).includes(role);
}

export function canDecideHiPatientIdentityDuplicateReview(
  role: string,
): role is HiPatientIdentityDuplicateDecisionRole {
  return (HI_PATIENT_IDENTITY_DUPLICATE_DECISION_ROLES as readonly string[]).includes(role);
}
